import { PhoneCall } from "lucide-react";

const FloatingCallButton = () => (
  <a
    href="tel:0184160307"
    className="hidden md:flex fixed bottom-6 right-6 z-40 bg-brand-red text-white rounded-full px-5 py-3 shadow-lg hover:bg-red-700 transition items-center gap-2"
    data-testid="floating-call-button"
  >
    <PhoneCall size={16} />
    <span className="text-xs uppercase tracking-wider font-semibold" data-testid="floating-call-text">
      Urgence 24h/24
    </span>
  </a>
);

export default FloatingCallButton;
